import {createClient} from '@supabase/supabase-js'

// Create a single supabase client for interacting with your database

const supabaseUrl = 'https://beozideqkbgwtxmymicp.supabase.co'
const supabaseKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJlb3ppZGVxa2Jnd3R4bXltaWNwIiwicm9sZSI6ImFub24iLCJpYXQiOjE2Nzg1NDIyMzYsImV4cCI6MTk5NDExODIzNn0.AvO1vN8Cee4ByXU6bcDQ6xZpWzh-h5rPaQJsnQf7poQ'
const supabase = createClient(supabaseUrl, supabaseKey)

export {supabase}
